
<script>
  import { 
    Row, Column, Block, Icon, Text, TextInput, Link,
    Image, Toast, Select, NumberInput, Switch
  } from 'bastone'
  import { colors } from '../consts'
  import Page from '../components/page.svelte'
  import Header from '../components/header.svelte'
  import MyButton from '../components/button.svelte'
  import Avatar from '../components/avatar.svelte'
  import { ChatBot, ChatSession, ChatMessage, DataSet } from '../models'
  import { Context, notify, screenWidth, bodyWidth, currentUser, isDesktop } from '../context'
  import { onMount } from 'svelte'
  
  import Confirm from '../components/confirm.svelte'
  import { escapeContent } from '../utils'
  
  import { marked } from 'marked'
  import { markedHighlight } from 'marked-highlight'
  import markedKatex from 'marked-katex-extension'
  import hljs from 'highlight.js'

  let inputContent = ''
  let waiting = false
  
  let inputElement = null
  let messageList = []
  let sessionList = []
  let currSession = {}
  let hoveringSessionNo = -1
  let hoveringMessageNo = -1
  let currBot = {}
  let confirm = null
  let currBox = 1
  
  async function sendMessage() {
    inputContent = inputContent.trim()
    if (waiting || !inputContent) return

    waiting = true
    let msg = new ChatMessage({
      session_id: currSession.id, 
      content: inputContent,
      history_count: currSession.history_count,
      prompt_vars: currSession.prompt_vars,
      search: currSession.search,
    })

    let ok = await msg.create()
    if (!ok) {
      console.log(msg, 'create fail!')
      waiting = false
      return 
    }

    if (!currBot.auto_reply) {
      messageList.unshift(msg)
      messageList = messageList
      inputContent = ''
      waiting = false
      return
    }

    messageList.unshift(msg)
    messageList = messageList
    inputContent = ''
    
    let respMessage = new ChatMessage({role: 'assistant', content: ''})
    let loadingMessage = new ChatMessage({role: 'assistant', content: '.'})
    messageList.unshift(loadingMessage)
    messageList = messageList
    let loading = true
    let loadingTimer = setInterval(()=>{
      if (!loading) return
      loadingMessage.content += ' .'
      messageList[0] = messageList[0]
    }, 1000)

    inputElement.focus()

    if (sessionList[0] != currSession) {
      reloadSessionList()
    }

    await msg.stream(
      (msg) => {
        let data = msg.data.trim();
        if (data == '') return;
        if (waiting == false) {
          throw new Error('EMPTY')
        }
        if (loading) {
          loading = false
          clearInterval(loadingTimer)
        }
        let d = JSON.parse(data)
        if (d.hasOwnProperty('id')) {
          let messageId = d.id
          delete d['id']
          if (!respMessage.hasOwnProperty('id')) {
            respMessage.id = messageId 
          } else if (messageId !== respMessage.id) {
            respMessage = new ChatMessage({id: messageId, role: 'assistant', content: ''})
            messageList.unshift(respMessage)
          }
        }
        for (let k in d) {
          respMessage[k] = (respMessage[k] || '') + d[k]
        }
        messageList[0] = respMessage
      },
    )

    if (waiting) {
      waiting = false
      if (messageList[0].content == '...') {
        messageList.splice(0, 1)
        messageList = messageList
      }
      Context.reloadUser()
    }

    if (loading) {
      loading = false
      clearInterval(loadingTimer)
    }

    /* Fuck native EventSource API
    let source = msg.stream()
    source.onmessage = (e) => {
      let data = e.data.trim();
      if (data == '') return;
      if (waiting == false) {
        source.close() // abort
        return 
      }
      let d = JSON.parse(data)
      for (let k in d) {
        respMessage[k] = (respMessage[k] || '') + d[k]
      }
      messageList[0] = respMessage
    }
    source.onerror = (e)=>{
      source.close()
      if (waiting) {
        waiting = false
        Context.reloadUser()
      }
    }
    source.addEventListener('end', (e) => {
      source.close()
      if (waiting) {
        waiting = false
        Context.reloadUser()
      }
    }, false); */
  }

  async function starMessage(index, message) {
    if (!message.id) 
      return
    let ok = message.starred ? await message.unstar() : await message.star()
    if (!ok) return 
    message.starred = !message.starred
    messageList[index] = message
    notify(message.starred ? '已收藏' : '已取消收藏')
  }

  async function deleteMessage(index, message) {
    if (!message.id) 
      return
    let ok = await message.delete()
    if (!ok) return 
    messageList.splice(index, 1)
    messageList = messageList
  }

  async function clearSession() {
    if (waiting || messageList.length == 0)
      return

    confirm.show('确定要清空对话吗？', async()=>{
      let ok = await currSession.clear()
      if (ok) messageList = []
      switchBox(1)
    })
  }

  async function createSession() {
    let session = new ChatSession({
      bot_id: currBot.id, 
      user_id: $currentUser.id, 
    })

    let ok = await session.create()
    if (!ok) {
      notify('创建对话失败')
      return
    }
    ok = await reloadSessionList()
    if (ok) reloadSession(sessionList[0])
    switchBox(1)
  }

  async function deleteSession(session) {
    if (sessionList.length == 1) {
      notify('再删就没了...')
      return
    }
    await session.delete()
    let ok = await reloadSessionList()
    if (ok) reloadSession(sessionList[0])
  }

  async function reloadSessionList(botId) {
    sessionList = await ChatSession.getList(botId)
    if (!sessionList) {
      notify('未获取到对话列表,请刷新')
      return false
    }
    return true
  }

  function reloadSession(session) {
    if (currSession.id == session.id) 
      return
    waiting = false // abort streaming
    currSession = session
    ChatBot.getOne(session.bot_id).then((res) => {
      currBot = res
      for (let pvar of currBot.prompt_vars) {
        if (!session.prompt_vars.hasOwnProperty(pvar.name)) {
          session.prompt_vars[pvar.name] = pvar.default
        }
      }
    })
    ChatMessage.getList(session.id).then((res) => {
      messageList = res
    })
  }

  async function followBot() {
    if (!currBot) return
    if (currBot.user_id == $currentUser.id) {
      notify('不需要关注自己创建的BOT')
      return
    }
    
    if (currBot.following) {
      await currBot.unfollow()
    } else {
      await currBot.follow()
    }
    currBot = currBot
  }

  function openDataSet() {
    if (!$currentUser.is_pro) {
      confirm.show('数据集功能仅供PRO会员使用')
      return 
    }

    if (!currBot) return
    if (!currBot.collection_name) {
      confirm.show('启用后可上传私有数据集/知识库，确定要开启吗？', ()=>{
        DataSet.enable(currBot.id).then(ok=>{
          if (!ok) return 
          location.href = `/bot/${currBot.id}/dataset`
        })
      })
    } else {
      location.href = `/bot/${currBot.id}/dataset`
    }
  }

  function switchBox(box) {
    currBox = box
  }

  onMount(async () => {
    let queryParams = new URLSearchParams(window.location.search);
    let botId = queryParams.get('bot_id') || ''
    if (botId) window.history.replaceState(null, null, '/chat')
    let ok = await reloadSessionList(botId)
    if (ok) {
      let session = sessionList[0]
      if (botId && botId != session.bot_id) {
        for (let i = 0; i < sessionList.length; i++) {
          if (sessionList[i].bot_id == botId) {
            session = sessionList[i]
            break
          }
        }
      }
      reloadSession(session)
    }

    hljs.configure({ignoreUnescapedHTML: true})
    const renderer = new marked.Renderer();
    renderer.link = function (href, title, text) {
      return `<a target="_blank" href="${href}">${text}` + '</a>';
    }
    marked.use({breaks: true, silent: true, renderer: renderer})
    marked.use(
      markedHighlight({
        langPrefix: 'hljs language-',
        highlight(code, lang) {
          if (hljs.getLanguage(lang)) {
            return hljs.highlight(code, {language:lang}).value
          } else {
            return hljs.highlightAuto(code).value
          }
        }
      })
    )
    marked.use(markedKatex({throwOnError: false, strict: false}))

    setInterval(()=>{
      if (document.hidden) return
      if (!currBot.auto_reply) {
        let sid = currSession.id
        ChatMessage.getList(sid).then((res) => {
          if (sid === currSession.id) messageList = res
        })
      }
      ChatSession.getList().then((res) => {
        if (res && res.length > 0) sessionList = res
      })
    }, 8000)
  })


</script>

<svelte:head>
  <link rel="stylesheet" href="/highlight/styles/github-dark-dimmed.min.css">
</svelte:head>


<Confirm bind:this={confirm}/>
<Page title='ChatGPT对话'>
  <Header buttonType='home'/>

  <Row align=center xAlign=stretch width={$screenWidth>1440?$bodyWidth:'100%'} minWidth=80% height=100% overflowY=hidden>
    {#if $isDesktop || currBox == 0}
    <Block name=sessionbox width={$isDesktop?'18%':'100%'} 
      overflowY=auto minWidth=10.6rem borderColor={colors.lightGray}
      leftBorder={$screenWidth>1440?1:0} rightBorder={$isDesktop?1:0}
    >
      <Column overflowY=auto width=100%>
        {#each sessionList as session, i}
        <Block selectable={false} width=100%
          activeBgColor={colors.lightWhite} hoverBgColor={colors.snow}
          backgroundColor={session.id==currSession.id?colors.lightWhite:colors.white}
          on:click={()=>{reloadSession(session);switchBox(1)}}
          on:mouseenter={()=>hoveringSessionNo=i}
          on:mouseleave={()=>hoveringSessionNo=-1}
        >
          <Row height=4rem>
            <Block minWidth=0.8rem/>
            <Image url={session.bot.avatar_url} height=2.5rem/>
            <Block minWidth=0.6rem/>
            <Column overflow=hidden width=100%>
              <Row width=100%>
                <Text size=1rem lineHeight=1.3rem>
                  {(session.bot.type==1&&session.user_id!=$currentUser?.id)?`@${session.user_name}`:session.bot.name}
                </Text>
                {#if i === hoveringSessionNo }
                <Block expand=1/>
                <Block topMargin=-0.4rem cursor=pointer backgroundColor=transparent
                  on:click={(e)=>{e.stopPropagation();deleteSession(session)}}
                ><Icon name=close size=1.1rem/></Block>   
                {/if}
              </Row>          
              <Block height=0.2rem backgroundColor={colors.transparent}/>
              <Text size=0.7rem textOverflow=ellipsis>{session.latest_message || '新对话'}</Text>
            </Column>
            <Block width=0.8rem/>
          </Row>
        </Block>
        {/each}
      </Column>
    </Block>
    {/if}

    {#if $isDesktop || currBox == 1}
    <Column width={$isDesktop?'64%':'100%'} height=100%>
      <Block name=sendbox bottomBorder=1 borderColor={colors.lightGray}>
        <Row width=100% xAlign=center align=space-between>
          <TextInput multiline={$isDesktop} resize=vertical
            border=0 space=10 bind:value={inputContent} bind:input={inputElement}
            height={$isDesktop?'5rem':'3rem'} width=100%
            fontSize=1.05rem
            placeholder=输入问题，按回车发送{$isDesktop?'，Ctrl+回车换行':''}
            placeholderColor={colors.gray}
            on:keypress={(e)=>{
              if (e.ctrlKey && (e.keyCode == 13 || e.keyCode == 10)) {
                const start = inputElement.selectionStart
                const end = inputElement.selectionEnd
                const text = inputElement.value;
                let newText = text.slice(0, start) + '\n' + text.slice(end);
                inputElement.value = newText;
                inputElement.selectionStart = start + 1
                inputElement.selectionEnd = start + 1
                e.preventDefault()
                //inputContent += '\n'
              } else if(e.keyCode == 13 && !waiting ) {
                e.preventDefault()
                sendMessage()
              }
            }}
          />
          <MyButton 
            height={$isDesktop?'4rem':'2rem'} minWidth=5.2rem fontSize=1rem
            on:click={sendMessage}
          >{waiting?'等待...':'发送'}</MyButton>
          <Block minWidth=0.4rem/>
        </Row>
      </Block>
 
      <Block name=msgbox overflowY=auto width=100% expand=1>
        <Column>
          {#each messageList as message, i}
          <Block 
            hoverBgColor={colors.snow}
            on:mouseenter={()=>hoveringMessageNo=i}
            on:mouseleave={()=>hoveringMessageNo=-1}
          >
            <Block height=0.9rem/>
            <Row>
              <Block width=1rem/>
              {#if message.role == 'user'}
              <Block position=relative overflow=hidden zIndex=0>
                <Avatar user={message.user}/>
                {#if message.user?.is_pro}
                <Block position=absolute bottom=0 right=0>
                  <Image url='/images/verified.png' height=0.8rem/>
                </Block>
                {/if}
              </Block>
              {:else}
              <Image height=2rem url={currBot.avatar_url}/>
              {/if}
              
              <Block width=0.6rem/>
              <Column>
                <Text size=1.1rem bold=1>{message.role=='user'?message.user?.name:currBot.name}</Text>
                <Block height=0.1rem/>
              </Column>
              {#if hoveringMessageNo === i}
              <Block expand=1/>
              <Row height=2rem xAlign=flex-start>
                <Icon
                  name=copy size=1.2rem cursor=pointer
                  on:click={()=>{navigator.clipboard.writeText(message.content);notify('已复制')}}
                />
                <Block width=0.4rem/>
                <Icon 
                  name=favorite size=1.2rem cursor=pointer bold={message.starred}
                  on:click={()=>starMessage(i,message)}
                />
                <Block width=0.4rem/>
                <Icon 
                  name=ashbin size=1.2rem cursor=pointer
                  on:click={()=>deleteMessage(i,message)}
                />
              </Row>
              <Block width=0.6rem/>
              {/if}

            </Row>
            <Block height=0.8rem/>
            <Row>
              <Block minWidth=1rem/>
              <Text 
                wrap=1 size=1.05rem lineHeight=1.6rem width=100%
              >{@html marked.parse(escapeContent(message.content))}</Text>
              <Block minWidth=1rem/>
            </Row>
            <Block height=0.8rem/>
          </Block>
          {/each}

        </Column>
      </Block>
    </Column>
    {/if}

    {#if $isDesktop || currBox == 2}
    <Block name=botbox width={$isDesktop?'18%':'100%'} minWidth=9rem padding=0.8rem 
      leftBorder={$isDesktop?1:0} rightBorder={$screenWidth>1440?1:0} 
      borderColor={colors.lightGray} overflowY=auto
    >
      
      <Column width=100% xAlign=center>
        <Block height=1rem/>
        <Image url={currBot?.avatar_url} height=3rem/>
        <Block height=0.6rem/>
        <Text size=1.1rem bold=1>{currBot?.name}</Text>
        <Block height=0.6rem/>
        <Text wrap=1 size=0.8rem textOverflow=ellipsis>{currBot?.desc}</Text>

        <Block height=0.8rem/>
        <Row>
          <MyButton 
            width=4.2rem height=1.8rem border=1.5 iconSize=1rem space=0.2rem
            icon={(!currBot || !currBot.following) ? 'browse': null}
            on:click={followBot}
          >
            <Text size=0.9rem lineHeight=1.2rem>{currBot?.following?'已关注':'关注'}</Text>
          </MyButton>
          <Block width=1rem/>
          <MyButton 
            width=5rem height=1.8rem border=1.5 iconSize=1rem icon=comment space=0.2rem
            on:click={createSession}
          >
            <Text size=0.9rem lineHeight=1.2rem>新对话</Text>
          </MyButton>
        </Row>
      </Column>
      <Block height=1.8rem/>

      {#if currBot.prompt_vars && currBot.prompt_vars.length > 0}
      <Column>
        {#each currBot.prompt_vars as prompt_var}
        <Text size=0.9rem>{prompt_var.title}</Text>
        <Block height=0.4rem/>
        {#if prompt_var.type == 'option'}
        <Select 
          width=100% items={prompt_var.values.split(',')} current=0 
          bind:currentValue={currSession.prompt_vars[prompt_var.name]}
        />
        {:else if prompt_var.type == 'longtext'}
        <TextInput 
          width=100% height=3.3rem multiline=1 fontSize=0.9rem resize=vertical
          bind:value={currSession.prompt_vars[prompt_var.name]}
        />
        {:else}
        <TextInput 
          width=100% fontSize=0.9rem
          bind:value={currSession.prompt_vars[prompt_var.name]}
        />
        {/if}
        <Block height=0.6rem/>
        {/each}
      </Column>
      <Block height=1.2rem/>
      {/if}

      <Text size=1rem lineHeight=1.6em bold=1>对话设置</Text>
      <Block height=0.2rem/>
      {#if !currBot.manager_name || currBot.manager_name == 'base'}
      <Row height=2rem>
        <Toast top=1.8rem left=0>
          <Icon slot=target name=search size=1.1rem></Icon>
          <Block slot=toast backgroundColor={colors.translucent} padding=0.4rem width=11rem>
            <Text color=white size=0.8rem wrap=1>
              联网使用搜索引擎，将搜索结果发送给GPT(因此会消耗额外Token)，开启后将忽略历史消息
            </Text>
          </Block>
        </Toast>
        <Block width=0.4rem/>
        <Text size=1rem lineHeight=2rem>联网搜索</Text>
        <Block width=0.2rem/>
        <Image url='/images/rednew.png' height=1.1rem/>
        <Block expand=1 maxWidth=5rem/>
        <!--<Select 
          width=4.8rem height=1.5rem items={searchItems} fontSize=0.8rem
          bind:currentValue={currSession.search}
        />-->
        <Switch bind:on={currSession.search} onColor={colors.black} width=2.8rem height=1.3rem/>
      </Row>
      <Row height=2rem>
        <Toast top=1.8rem left=0>
          <Icon slot=target name=history size=1.1rem></Icon>
          <Block slot=toast backgroundColor={colors.translucent} padding=0.4rem width=11rem>
            <Text color=white size=0.8rem wrap=1>
              每次发送附带的历史消息数，越多上下文越丰富，越少越省点数。另外总长度过大也会被截断
            </Text>
          </Block>
        </Toast>

        <Block width=0.4rem/>
        <Text size=1rem lineHeight=2rem>发送消息数</Text>
        <Block expand=1 maxWidth=2.5rem/>
        <NumberInput 
          minValue=0 maxValue=10 stepValue=2
          bind:value={currSession.history_count}
        />
      </Row>
      {/if}
      <Block selectable={false} cursor=pointer on:click={clearSession}>
        <Row height=2rem>
          <Icon name=ashbin size=1.1rem/>
          <Block width=0.4rem/>
          <Text size=1rem lineHeight=2rem hoverUnderline=1>清空历史消息</Text>
        </Row>
      </Block>

      {#if currBot?.user_id === $currentUser?.id || $currentUser?.is_admin}
      <Block height=1.2rem/>
      <Text size=1rem lineHeight=1.6rem bold=1>BOT管理 *</Text>
      <Block height=0.2rem/>
      <Link url={`/editbot/${currBot.id}`}>
        <Block 
          selectable={false}
        >
          <Row height=2rem>
            <Icon name=setting size=1.1rem/>
            <Block width=0.4rem/>
            <Text size=1rem lineHeight=2rem hoverUnderline=1>修改配置项</Text>
          </Row>
        </Block>
      </Link>
      <Block 
        selectable={false} cursor=pointer 
        on:click={openDataSet}
      >
        <Row height=2rem>
          <Icon name=layers size=1.1rem/>
          <Block width=0.4rem/>
          <Text size=1rem lineHeight=2rem hoverUnderline=1>{currBot.collection_name?'管理':'启用'}数据集</Text>
        </Row>
      </Block>
      {/if}
    </Block>
    {/if}
  </Row>

  {#if $screenWidth < 768}
  <Block name=bottomtab width=100% topBorder=1 position=sticky bottom=0 backgroundColor=white borderColor={colors.lightGray}>
    <Row height=3rem align=space-around>
      <Block selectable={false} cursor=pointer on:click={()=>{switchBox(0)}}>
        <Row>
          <Icon name=menu size=1.2rem bold={currBox==0}/>
          <Block width=0.3rem/>
          <Text size=1.1rem lineHeight=3rem bold={currBox==0}>列表</Text>
        </Row>
      </Block>
      <Block selectable={false} cursor=pointer on:click={()=>{switchBox(1)}}>
        <Row>
          <Icon name=comment size=1.2rem bold={currBox==1}/>
          <Block width=0.3rem/>
          <Text size=1.1rem lineHeight=3rem bold={currBox==1}>对话</Text>
        </Row>
      </Block>
      <Block selectable={false} cursor=pointer on:click={()=>{switchBox(2)}}>
        <Row>
          <Icon name=setting size=1.2rem bold={currBox==2}/>
          <Block width=0.3rem/>
          <Text size=1.1rem lineHeight=3rem bold={currBox==2}>设置</Text>
        </Row>
      </Block>
    </Row>
  </Block>
  {/if}

</Page>


